// @flow

import type { UUID } from 'esm-web-pro/types/common';
import Resource from 'speed-js-core/src/api/Resource';

export default class FinancialDocumentDraftResource extends Resource {
    basePath: string = 'billing/financial-documents-drafts/';

    objectPath: string = 'billing/financial-documents-drafts/{ident}/';

    discard(uuid: UUID) {
        return this.client._request(`${this._getObjectPath(uuid)}discard/`, 'POST');
    }
}
